import module from '@kendu/ui/module'
import { element } from 'angular'

export class KdElementModalService {
  constructor ($document) {
    this.document = $document
    this.container = undefined
    this.parent = undefined
    this.current = null
    this.modals = []
  }

  add (modal) {
    if (this.modals.indexOf(modal) >= 0) return

    if (!this.parent) {
      this.parent = (modal.controller('appInterface') && modal.controller('appInterface').element) || element(this.document[0].body)
    }

    if (!this.container) {
      this.container = element('<div class="ui-modal"></div>')
      this.parent.prepend(this.container)
    }

    this.modals.push(modal)

    this.update()

    return () => {
      this.modals.forEach((item) => {
        if (item !== modal) return

        this.modals.splice(this.modals.indexOf(item), 1)
        item.detach()
      })

      this.update()

      return modal
    }
  }

  update () {
    if (this.modals.length === 0) {
      this.container.remove()
      this.container = null
      this.current = null
    } else {
      if (this.current !== this.modals[this.modals.length - 1]) {
        this.current = this.modals[this.modals.length - 1]

        this.modals.forEach((item) => {
          if (item !== this.current) {
            item.detach()
          } else {
            this.container.append(item)

            if (item[0].focus) item[0].focus()
          }
        })
      }
    }
  }
}

module.service('KdElementModalService', KdElementModalService)



// WEBPACK FOOTER //
// ./src/kendu/ui/services/KdElementModal.js